module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/area-6-f47785cb26f61db373945905618bd6d2.jpg";